/**
 * SCRUM-87 (DS-008-4) — StalePreconditionBody schema.
 *
 * Shared across DS-007 v8 + DS-008-7. The `currentVersion` field carries the
 * version the server currently holds, so clients can update their cached ETag
 * and retry without a fresh GET.
 *
 * Schema: `{ currentVersion: number (integer, non-negative) }` — strict mode.
 */
import { z } from 'zod';
export const stalePreconditionBodySchema = z.object({
    currentVersion: z.number().int().nonnegative(),
}).strict();
//# sourceMappingURL=stale-precondition-body.schema.js.map